export enum IconNames {
    Belt = "belt",
    Date = "date",
    Engine = "engine",
    Fan = "fan",
    Gearbox = "gearbox",
    Speed = "speed",
    MoTorCycle = "motorCycle",
    Facebook = "facebook",
}
